import { connect, Dispatch } from 'react-redux';

import Log from 'providers/log';

import { IRootState } from 'redux/root_reducer';

import CartItem from 'types/shopify/CartItem';

import CartItemRow, { DispatchProps, OwnProps, StateProps } from 'components/pages/accessories/cart/CartItemRow';
import { Action, remove, update } from 'redux/modules/shopify';

const mapStateToProps = ({ shopify }: IRootState, { item }: OwnProps): StateProps => {
    return {
        price: 0 // this should be removed, but had ts issues and need it to work now:(
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        removeItem: (item: CartItem) => dispatch(remove(item)),
        updateItem: (item: CartItem) => dispatch(update(item))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemRow);



// WEBPACK FOOTER //
// ./src/containers/pages/accessories/cart/CartItemRow.tsx